import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import ExpandButtonToggle from 'features/company/Chart/ExpandButtonToggle';
import TimeframeButtons from 'features/company/Chart/TimeframeButtons';
import numeral from 'numeral';
import { chartTimeframesFR } from 'features/company/constants';
import { FRChartTimeFrames } from '../../constants.types';
import ChartTypeButtons from './ChartTypeButtons';
import { FRChartType, ILastPriceInfo } from '../types';
import { ChartSectionItem } from './styled';

interface ChartHeaderProps {
  onExpand: () => void;
  timeframe: FRChartTimeFrames;
  chartType: FRChartType;
  isChartVisible: boolean;
  priceInfo?: ILastPriceInfo;
  onSelectTimeframe: (v: FRChartTimeFrames) => void;
  onSelectChartType: (v: FRChartType) => void;
}

function ChartHeader({
  timeframe,
  chartType,
  isChartVisible,
  priceInfo,
  onSelectTimeframe,
  onSelectChartType,
  onExpand,
}: Readonly<ChartHeaderProps>) {
  const renderYield = () => (
    <ChartSectionItem>
      <Text weight="bold">{numeral(priceInfo?.yield).format('0.00')}%</Text>
      {/* @ts-expect-error */}
      <Text color="#858585" size="12px" pt="3px">
        Yield
      </Text>
    </ChartSectionItem>
  );

  const renderBuyPrice = () => (
    <ChartSectionItem>
      <Text weight="bold">{numeral(priceInfo?.bidPrice).format('0.00')}%</Text>
      {/* @ts-expect-error */}
      <Text color="#858585" size="12px" pt="3px">
        Harga Beli
      </Text>
    </ChartSectionItem>
  );

  const renderSellPrice = () => (
    <ChartSectionItem>
      <Text weight="bold">
        {numeral(priceInfo?.offerPrice).format('0.00')}%
      </Text>
      {/* @ts-expect-error */}
      <Text color="#858585" size="12px" pt="3px">
        Harga Jual
      </Text>
    </ChartSectionItem>
  );

  const renderChartType = () => (
    <ChartTypeButtons
      chartType={chartType}
      onSelectChartType={onSelectChartType}
      showChartType
    />
  );

  const renderExpandButtonToggle = () => (
    <ExpandButtonToggle onExpand={onExpand} />
  );

  return (
    <div>
      <Flex
        align="center"
        justify="space-between"
        style={{ background: '#FFFFFF' }}
        // @ts-expect-error
        p="20px"
      >
        <Flex style={{ gap: 20 }}>
          {renderYield()}
          {renderBuyPrice()}
          {renderSellPrice()}
        </Flex>
        {renderExpandButtonToggle()}
      </Flex>
      {isChartVisible && (
        <Flex
          align="center"
          justify="space-between"
          style={{ background: '#FFFFFF' }}
          // @ts-expect-error
          px="20px"
        >
          {renderChartType()}
          <TimeframeButtons
            showTimeframes
            timeframe={timeframe}
            onSelectTimeframe={onSelectTimeframe}
            timeFrameList={chartTimeframesFR}
          />
        </Flex>
      )}
    </div>
  );
}

export default ChartHeader;
